import {inject, Injectable} from '@angular/core';
import {HomeFeedSection, HomeFeedService} from "@brightside-web/desktop/feature/home-feed";
import {ServiceInventoryService, ServiceState} from "@brightside-web/desktop/data-access/service-inventory";
import {filter, Subscription, tap} from "rxjs";
import {SurveyMoneyHelpCardComponent} from "./home-cards/survey-money-help-card/survey-money-help-card.component";
import {SurveyActionCardComponent} from "./home-cards/survey-action-card/survey-action-card.component";

@Injectable({
  providedIn: 'root'
})
export class SurveyCardsService {
  private _homeFeedService = inject(HomeFeedService);
  private _serviceInventory = inject(ServiceInventoryService);
  private _sub = new Subscription();

  constructor() {
    this._sub.add(
      this._serviceInventory.getService('survey_emoney')
        .pipe(
          filter((service) => !!service),
          tap((service) => {
            switch (service.state) {
              case ServiceState.INITIAL:
              case ServiceState.PENDING:
              case ServiceState.COMPLETE:
                this.registerSurveyEmoneyCard(service.route);
                if(service.state === ServiceState.PENDING) {
                  this.registerSurveyEmoneyActionCard(service.route);
                }
                break;
            }
          })
        ).subscribe()
    )
  }

  private registerSurveyEmoneyActionCard(surveyType?: string) {
    this._homeFeedService.registerHomeFeedCard({
      key: 'survey_emoney_action',
      component: 'SurveyActionCardComponent',
      componentRef: SurveyActionCardComponent,
      data: { surveyType },
      order: 40,
      section: HomeFeedSection.ACTIONS
    });
  }

  private registerSurveyEmoneyCard(surveyType?: string) {
    this._homeFeedService.registerHomeFeedCard({
      key: 'survey_emoney',
      component: 'SurveyMoneyHelpCardComponent',
      componentRef: SurveyMoneyHelpCardComponent,
      data: { surveyType },
      order: 1,
      section: HomeFeedSection.MYMONEYHELP
    });
  }
}
